/**
 * CMS Contact form validation
 * - highlights required fields
 * - shows inline "Required" messages
 */
(function () {
    function ready(fn) {
      if (document.readyState !== "loading") fn();
      else document.addEventListener("DOMContentLoaded", fn);
    }
  
    ready(function () {
      var form = document.getElementById("ContactFormNative");
      if (!form) return;
  
      var requiredFields = form.querySelectorAll("[required]");
  
      function setError(el, on) {
        if (!el || !el.id) return;
        el.setAttribute("aria-invalid", on ? "true" : "false");
        var msg = form.querySelector('[data-error-for="' + el.id + '"]');
        if (msg) msg.classList.toggle("hidden", !on);
      }
  
      function validate(el) {
        var invalid = !el.checkValidity();
        setError(el, invalid);
        return !invalid;
      }
  
      requiredFields.forEach(function (el) {
        ["input", "change", "blur"].forEach(function (evt) {
          el.addEventListener(evt, function () { validate(el); });
        });
      });
  
      form.addEventListener("submit", function (e) {
        var ok = true;
        requiredFields.forEach(function (el) { if (!validate(el)) ok = false; });
  
        if (!ok) {
          e.preventDefault();
          var first = form.querySelector('[aria-invalid="true"]');
          if (first) {
            first.focus({ preventScroll: true });
            first.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      });
    });
  })();
  